<script lang="ts" setup>
import type { Component } from "vue";
import { computed, inject, ref, watch } from "vue";

import DropdownMenu from "~/components/dumb/DropdownMenu.vue";
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import { DROPDOWN_REGISTER_SUBDROPDOWN_STATE } from "~/constants/injection";
import { Placement } from "~/shared/enums";
import type { DropdownMenuSection } from "~/shared/types";

const props = defineProps<{
  title: string;
  icon?: Component;
  iconArgs?: object;
  iconAfter?: Component;
  iconAfterArgs?: object;
  preventCloseOnSelect?: boolean;
  sections: DropdownMenuSection[];
  widthPixels?: number;
  headerTitle?: string;
  rightText?: string;
  rightTextStyle?: string;
  disabled?: boolean;
  itemIndex?: number;
}>();

const dropdownMenuRef = ref<InstanceType<typeof DropdownMenu> | null>(null);

const isOpen = computed(() => dropdownMenuRef.value?.isOpen ?? false);

const registerSubdropdownState = inject(DROPDOWN_REGISTER_SUBDROPDOWN_STATE, null);

watch(isOpen, (newValue) => {
  if (registerSubdropdownState && props.itemIndex !== undefined) {
    registerSubdropdownState(props.itemIndex, newValue);
  }
});

const onClick = () => {
  if (!isOpen.value) {
    return;
  }
  dropdownMenuRef.value?.close();
};

defineExpose({
  isOpen,
});
</script>

<template>
  <DropdownMenu
    ref="dropdownMenuRef"
    :sections="sections"
    :placement="Placement.RIGHT_TOP"
    :prevent-close-on-select="preventCloseOnSelect"
    :width-pixels="widthPixels"
    :header-title="headerTitle"
    mobile-include-back
    class="w-full"
    @keydown.enter.stop
    @click.capture.stop="onClick">
    <DropdownMenuItemContent
      :icon="icon"
      :icon-args="iconArgs"
      :title="title"
      is-submenu
      :icon-after="iconAfter"
      :icon-after-args="iconAfterArgs"
      :right-text="rightText"
      :right-text-style="rightTextStyle"
      :disabled="disabled" />
  </DropdownMenu>
</template>
